import { Category, MenuItem } from '@v2/shared/lib/types';

import SpecialDealsPanel from './SpecialDealsPanel';
import CategoriesPanel from '../CategoriesPanel';

type Props = {
  categories: Category[];
  featuredCategories: Category[];
  specialDealLinks: MenuItem[];
  closeMainMenu: () => void;
};

export default function MagazinesMenu({ categories, featuredCategories, specialDealLinks, closeMainMenu }: Props) {
  return (
    <>
      <CategoriesPanel
        title="Our top categories"
        categories={categories}
        featuredCategories={featuredCategories}
        closeMainMenu={closeMainMenu}
      />
      <SpecialDealsPanel specialDealLinks={specialDealLinks} closeMainMenu={closeMainMenu} />
    </>
  );
}
